import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/base/SEO';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedAnime from './components/FeaturedAnime';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import ArticleList from './components/ArticleList';

export default function Home() {
  useEffect(() => {
    document.title = '天天动漫 - 每天追番看动漫，海量资源免费在线';
  }, []);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '天天动漫是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '天天动漫是一个专注于动漫在线观看与资讯的平台，提供热门新番、经典老番、国漫日漫等海量动漫资源，高清免费在线观看。',
        },
      },
      {
        '@type': 'Question',
        name: '天天动漫的番剧多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '天天动漫保持每日更新，按照各番剧的播出时间同步更新最新剧集，热门新番通常在播出后数小时内即可观看。',
        },
      },
      {
        '@type': 'Question',
        name: '天天动漫支持哪些动漫类型？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '天天动漫涵盖热门新番、日漫精选、国漫专区、经典老番、剧场版、OVA/特别篇等丰富类型，满足不同观众的追番需求。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在天天动漫上找到想看的番剧？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过首页的分类导航、热门推荐、排行榜，或使用搜索功能快速找到您感兴趣的作品。每个作品都有详细的介绍和标签帮助您选择。',
        },
      },
    ],
  };

  return (
    <>
      <SEO />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '天天动漫 - 首页',
          description: '天天动漫是你每天追番的首选平台，汇聚海量动漫资源，涵盖热门新番、经典老番、国漫日漫，高清免费在线观看。',
        }}
      />
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedAnime />
          <CategoryNav />
          <LatestUpdates />
          <ArticleList />
        </main>
        <Footer />
      </div>
    </>
  );
}